import { MAX_LIST_VISIBLE_INDENTATION } from '../consts.js';

function normalizeOffset(offset) {
  return offset < 0 ? 0 : offset > MAX_LIST_VISIBLE_INDENTATION ? MAX_LIST_VISIBLE_INDENTATION : offset;
}

export { normalizeOffset };
//# sourceMappingURL=normalizeOffset.js.map
